import React, {Component} from 'react';
import {Popup} from 'react-leaflet';
import {connect} from 'react-redux';
import {
  closeGraphsView,
  closePopup,
  openGraphsView,
  setMapCenter,
  toggleAqfxPanel,
  togglePointDataDisplay,
  togglePopupExpanded
} from '../actions';
import {AEROLOGICAL_WS} from '../Constants';
import {formatPointValue, safeGetPointValue} from '../utils/point_utils';
import './PointDetails.css';
import PointExtendedDetails from './PointExtendedDetails';

class PointDetails extends Component {

  constructor(props, context) {
    super(props, context);
    this.popupRef = React.createRef();
  }

  onClose = () => {
    const { dispatch } = this.props;
    dispatch(closePopup());
  };

  onChartButtonClick = () => {
    const { dispatch, graphs_open, point_data_display_graph, point } = this.props;
    if (graphs_open) {
      if (point_data_display_graph) {
        dispatch(closeGraphsView());
      } else {
        dispatch(togglePointDataDisplay());
      }
    } else {
      dispatch(setMapCenter(point.lat, point.lng));
      dispatch(openGraphsView());
      if (!point_data_display_graph) {
        dispatch(togglePointDataDisplay());
      }
    }
  };

  onTableButtonClick = () => {
    const { dispatch, graphs_open, point_data_display_graph, point } = this.props;
    if (graphs_open) {
      if (!point_data_display_graph) {
        dispatch(closeGraphsView());
      } else {
        dispatch(togglePointDataDisplay());
      }
    } else {
      dispatch(setMapCenter(point.lat, point.lng));
      dispatch(openGraphsView());
      if (point_data_display_graph) {
        dispatch(togglePointDataDisplay());
      }
    }
  };

  onToggleExtendedDetails = () => {
    const { dispatch } = this.props;
    dispatch(togglePopupExpanded());
  };

  onToggleAqfxPanel = () => {
    const { dispatch } = this.props;
    dispatch(toggleAqfxPanel());
  };

  valueDiv = (value, layer) => {
    return <div className="value">{formatPointValue(value,
      layer.prefix,
      layer.units,
      layer.rounding_rule,
      layer.null_value,
      layer.value_names)}</div>;
  };

  otherValueDiv = (value, layer) => {
    if (value === null) {
      return null;
    }

    if (layer.prefix === 'FUEL_TYPE' ||
        (layer.value_names !== undefined && layer.value_names.scale !== undefined)) {
      return <div className="other_value">{`(${value})`}</div>;
    }

    if (layer.units === 'kts') {
      return <div className="other_value">{parseFloat(value).toFixed(layer.rounding_rule || 0) +
                                           ' ' +
                                           layer.units}</div>;
    }
  };

  incidentProperties = (incident) => {
    return <div>
      {Object.entries(incident.properties).filter(p => p[0] !== 'Name').map(
        (p, i) => <div className="extended" key={'point-extended-details-' + i}>
          <div className="emphasis">{p[0].replace(/_/g, ' ')}</div>
          <div className="indicator-value">{p[1]}</div>
        </div>
      )}
    </div>;
  };

  render() {
    const {
      point, layer, graphs_open, point_data_display_graph, active_incident,
      popup_open, popup_expanded, dragging,
      popup_data, aws_data, fms_data
    } = this.props;
    let popUp = null;
    if (popup_open && !(dragging) && point.lat !== null) {
      const primaryLayer = active_incident ? null : layer;
      const latitude = point.lat;
      const longitude = point.lng;
      const value_populated = !!popup_data.details;
      const extended_data_populated = !!popup_data.extended_data && popup_data.extended_data.length > 0;
      const nullValue = primaryLayer ? primaryLayer.null_value : null;
      const value = safeGetPointValue(popup_data, nullValue);
      popUp = <Popup position={point}
                     onClose={this.onClose}
                     maxHeight={document.documentElement.offsetHeight - 270}
                     autoClose={false}
                     maxWidth={500}
                     ref={this.popupRef}>
        <div className="c-point-details">
          {active_incident && active_incident.properties &&
           <div>
             <div className="indicator">BURN: {active_incident.properties.Name}</div>
             {this.incidentProperties(active_incident)}
           </div>
          }
          {value_populated && primaryLayer &&
           <div>
             <div className="indicator">{primaryLayer.displayName}</div>
             {this.valueDiv(value, primaryLayer)}
             {this.otherValueDiv(value, primaryLayer)}
           </div>
          }
          <div>
            <span className="emphasis">Lat:</span> {latitude ? latitude.toFixed(4) : 'Not set'}
            &nbsp;&nbsp;
            <span className="emphasis">Long:</span> {longitude ? longitude.toFixed(4) : 'Not set'}
          </div>
          <div>
            <span className="emphasis">MGRS:</span> {point.mgrs}
          </div>
          {aws_data &&
           <div className="aws_data">
             <div className="emphasis">Nearest WS:</div>
             <div className="station">
               <a href={aws_data.awsExternalUrl} target="bom_ws">
                 <i className="fa fa-external-link"/>
                 {aws_data.description} ({aws_data.distanceToPoint} km)
               </a>
               {AEROLOGICAL_WS.includes(aws_data.stationid) &&
                <div>
                  <a href={aws_data.aerologicaExternallUrl} target="bom_ws_aero">
                    <i className="far fa-chart-line"/>
                    Aerological Diagram (Actual)
                  </a>
                </div>}
               {aws_data.isAqfx &&
                <div>
                  <a onClick={this.onToggleAqfxPanel}>
                    <i className="far fa-chart-line"/>
                    Aerological Diagram (Modelled)
                  </a>
                </div>}
             </div>
           </div>
          }
          {fms_data &&
           <div className="fms_data">
             <div className="emphasis">Nearest FMS:</div>
             <div className="station">
               <a href={fms_data.externalUrl} target="fms">
                 <i className="fa fa-external-link"/>
                 {fms_data.name} ({fms_data.distanceToPoint} km)
               </a>
             </div>
           </div>
          }
          <div className="button-panel">
            <a id="point-details_toggle-chart"
               className={'c-button light icon-only'.concat(graphs_open && point_data_display_graph ? ' selected' : '')}
               title="Click to open charts"
               onClick={this.onChartButtonClick}>
              <i className="far fa-chart-line"/></a>
            <a id="point-details_toggle-table"
               className={'c-button light icon-only'.concat(graphs_open && !point_data_display_graph ?
                                                            ' selected' :
                                                            '')}
               title="Click to open tables"
               onClick={this.onTableButtonClick}>
              <i className="far fa-table"/></a>
            {extended_data_populated &&
             <a id="point-details_toggle-popup" className={'c-button light icon-only'.concat(popup_expanded ?
                                                                                             ' selected' :
                                                                                             '')}
                title={'Click to ' + (popup_expanded ? 'hide' : 'show') + 'extended details'}
                onClick={this.onToggleExtendedDetails}>
               <i className={popup_expanded ? 'fa fa-minus-circle' : 'fa fa-plus-circle'}/>
             </a>
            }
          </div>
          {popup_expanded && extended_data_populated &&
           <PointExtendedDetails popup_data={popup_data} aws_data={aws_data} popup={this.popupRef}
                                 onMount={this.onExtendedDetailsMount}/>}
        </div>
      </Popup>;
    }
    return popUp;
  }

  onExtendedDetailsMount = () => {
    const popup = this.popupRef.current;
    if (popup) {
      popup.leafletElement.update();
    }
  };
}

const mapStateToProps = state => {
  const active_indicators = state.indicators.indicators.filter(indicator => indicator.active === true);
  return {
    point: state.point,
    layer: active_indicators[0],
    popup_data: state.popup_data,
    graphs_open: state.view.graphs_open,
    point_data_display_graph: state.view.point_data_display_graph,
    popup_open: state.view.popup_open,
    popup_expanded: state.view.popup_expanded,
    aws_data: state.aws.active,
    fms_data: state.fms.active,
    active_incident: state.incidents.active,
    dragging: state.timeline_dnd.dragging
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PointDetails);



// WEBPACK FOOTER //
// ./src/containers/PointDetails.js